import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ScanReceiptContent from "../components/ScanReceiptContent";

export default function ScanReceiptPage() {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/dashboard');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <div 
      className="min-h-screen pb-24"
      style={{ backgroundColor: "#F8FAFC" }}
      data-testid="scan-receipt-page"
    >
      {/* Header */}
      <header 
        className="px-4 py-4 flex items-center gap-4 sticky top-0 z-10"
        style={{ backgroundColor: "#F8FAFC" }}
      >
        <button
          onClick={handleBack}
          className="w-10 h-10 rounded-full flex items-center justify-center transition-colors hover:bg-gray-100"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-6 h-6" style={{ color: "#1D4ED8" }} />
        </button>
        <h1 
          className="text-xl font-bold"
          style={{ color: "#18181B", fontFamily: "Manrope, sans-serif" }}
        >
          Scan Receipt
        </h1>
      </header>

      {/* Content */}
      <main className="px-4 pt-2">
        <ScanReceiptContent onComplete={handleComplete} isMobile={true} />
      </main>
    </div>
  );
}
